import Typography from '@mui/material/Typography';

import type { VatId } from '@e-socna/data-layer';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { formatPercent } from '../../../utils/format-percent.util';
import { formatAmount } from '../../../utils/format-amount.util';

import type { ServiceUsageCardCmp_Service } from './fragments/service.fragment';

export const ServiceValueInfos = ({
  value: { discountAmount, discountPercentage, priceExcludingVat, vatId },
}: Readonly<{ value: NonNullable<ServiceUsageCardCmp_Service['value']> }>) => {
  const { currenciesIdMap, vatsIdMap } = useReferencesContext();

  return (
    <>
      <Typography gutterBottom variant="body2">
        Montant HT : {formatAmount(priceExcludingVat, currenciesIdMap)}
      </Typography>
      <Typography gutterBottom variant="body2">
        TVA Appliquée : {vatsIdMap[vatId as VatId]?.label ?? 'Inconnue'}
      </Typography>
      <Typography gutterBottom variant="body2">
        Montant Fixe de Remise :{' '}
        {!discountAmount
          ? 'Aucun'
          : formatAmount(discountAmount, currenciesIdMap)}
      </Typography>
      <Typography gutterBottom variant="body2">
        Pourcentage de Remise :{' '}
        {!discountPercentage ? 'Aucun' : formatPercent(discountPercentage)}
      </Typography>
    </>
  );
};
